<template>
  <div class="containerWrapper">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <h1>Dataadmin</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Dropdown v-model="selectedCat" :options="cats" optionLabel="name" placeholder="Välj typ"></Dropdown>
          <br/><br/>
          <label>Id</label><br/>
          <InputText type="text" v-model="id" name="id" /><br/><br/>
          <Button v-if="selectedCat" label="Hämta data" @click="getData()"/>
        </div>
        <div class="col-md-6">
          <div v-if="data !== null">
            <br/><br/>
            <label>Namn</label><br/>
            <InputText type="text" name="name" v-model="id" /><br/><br/>
            <label>Data</label><br/>
            <v-json-editor class="jsonEditor" :data="data" :editable="true" @change="$forceUpdate()"></v-json-editor><br/><br/>
            <Button label="Spara" @click="saveData()"/>
          </div>
        </div>
      </div>
    </div>
    <Toast position="topright" />
  </div>
</template>
<script>
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
export default {
  name: 'Dataadmin',
  components: {
    InputText,
    Button,
    Textarea,
    Toast,
    Dropdown
  },
  data () {
    return {
      id: null,
      data: null,
      selectedCat: null,
      cats: [
        { name: 'Description', value: 'objectdescriptions' },
        { name: 'Data', value: 'objectdatas' }
      ]
    }
  },
  methods: {
    async getData () {
      this.data = null
      let response = await this.$http.get('/api/' + this.selectedCat.value + '/' + this.id)
      if (this.selectedCat.value === 'objectdescriptions') {
        this.data = response.data.schema
      } else {
        this.data = response.data.data
      }
    },
    saveData () {
      var url = '/api/' + this.selectedCat.value + '/' + this.id
      if (this.selectedCat.value === 'objectdescriptions') {
        this.$http
          .put(url, {
            objectdescription: {
              schema: this.data
            }
          })
          .then(response => {
            this.$toast.add({severity: 'success', summary: 'Data sparad', life: 3000})
          })
          .catch(error => console.log(error))
      } else {
        this.$http
          .put(url, {
            objectdata: {
              data: this.data
            }
          })
          .then(response => {
            this.$toast.add({severity: 'success', summary: 'Data sparad', life: 3000})
          })
          .catch(error => console.log(error))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataAdmin.vue